import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import FreeConsultationCTA from "./FreeConsultationCTA";
import MobileCTABar from "./MobileCTABar";
import SmartDemoPopup from "./SmartDemoPopup";
import SocialProofTicker from "./SocialProofTicker";
import SiteSchema from "./SiteSchema";
import SmartContactRouter from "./SmartContactRouter";

export default function Layout() {
    return (
        <div className="min-h-screen flex flex-col bg-[#F8FAFC]">
            <SiteSchema />
            <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-3 focus:py-1.5 focus:bg-[#1E3A8A] focus:text-white focus:rounded">
                Skip to content
            </a>
            <Navbar />
            <main id="main" className="flex-1">
                <Outlet />
            </main>
            <Footer />
            {/* spacer for fixed mobile CTA bar so content above isn't hidden (V48 — bumped to h-20 to clear safe-area inset; xl: keeps lg-tablets ≤1279px in the mobile-style layout) */}
            <div className="h-20 xl:hidden" aria-hidden="true" />
            <WhatsAppButton />
            <FreeConsultationCTA />
            <MobileCTABar />
            <SmartDemoPopup />
            <SocialProofTicker />
            <SmartContactRouter />
        </div>
    );
}
